var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('template-loader',{attrs:{"theme":"skrn","showHeader":true,"showSidebar":false,"showFooter":true,"isLanding":true,"uuid":_vm.fetchPageByUuid,"pages":_vm.fetchPages}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }